import { getBrandLogMetadata } from '@/lib/brand/loggingMetadata';
import type { BrandLogMetadata } from '@/lib/brand/loggingMetadata';
import { getBrandContext } from '@lib-server/brand/getBrandContext';
import type { IncomingMessage } from 'http';

type RequestLike = Pick<IncomingMessage, 'headers'>;

export type { BrandLogMetadata };
export { getBrandLogMetadata };

export const getBrandLogMetadataFromRequest = (
  req?: RequestLike | null
): BrandLogMetadata => getBrandLogMetadata(getBrandContext(req));
